import { Box, Text, Flex } from "@chakra-ui/layout";
import { Col, Row, Empty } from "antd";
import PageHeader from "components/Page/PageHeader";
import SelectMonthYear from "components/Input/SelectMonthYear";
import { useState, useEffect } from "react";
import moment from "moment";
import colors from "core/resources/theme/colors";
import DashboardConciliacao from "../DashboardConciliacao";
import TableConciliacao from "./components/TableConciliacao";
import ConciliacaoDias from "./components/ConciliacaoDias";
import useConciliacaoBancaria from "features/conciliacao-bancaria/hooks/useConciliacaoBancaria";
import useDashboardConciliacaoBancaria from "features/conciliacao-bancaria/hooks/useDashboardConciliacaoBancaria";
import ModalProcessarArquivos from "./components/TableConciliacao/components/ModalProcessarArquivos";
import { useLoading } from "components/GlobalLoading";
import { checkPermission } from "infra/helpers/permission";
import { PermissaoEnum } from "core/resources/enums/permissao";
import useFiltroConciliacao from "./components/TableConciliacao/components/ModalFiltroConciliacao/hooks/useFiltroConciliacao";
import SelectContaBancaria from "ui/components/Input/SelectContaBancaria";
import ExportMenu from "components/ExportMenu";
import { exportExcelConciliacaoBancaria } from "./helper/util";

function ListaConciliacaoBancaria() {
  const { filtro, onChangeFiltro } = useFiltroConciliacao();
  // const [modalFiltrosOpen, setModalFiltrosOpen] = useState(false);

  const mesFiltro = moment(filtro.date).format("YYYY-MM");
  const [selectedDia, setSelectedDia] = useState<number | undefined>(undefined);

  const { data, isLoading, isFetching, refetch } = useConciliacaoBancaria({
    mes: mesFiltro,
    contasBancariasIds: filtro.contasBancariasIds,
  });

  const {
    data: dashboard,
    isLoading: isLoadingDashboard,
    isFetching: isFetchingDashboard,
  } = useDashboardConciliacaoBancaria({
    mes: mesFiltro,
    dia: selectedDia,
    contasBancariasIds: filtro.contasBancariasIds,
  });

  const [isOpenModal, setIsOpenModal] = useState(false);

  useLoading(isLoading || isFetching);

  const _items = data?.items.filter((item) =>
    selectedDia ? moment(item.data).date() === selectedDia : true
  );

  useEffect(() => {
    setSelectedDia(undefined);
  }, [filtro.date]);

  const hasPermissionImportar = checkPermission(
    PermissaoEnum.Backoffice.Financeiro.ConciliacaoBancaria.Conciliar
  );

  return (
    <>
      <PageHeader
        title="Conciliação Bancária"
        mb="24px"
        midComponent={
          <Flex w="550px" gap={4} alignItems="center">
            <SelectMonthYear
              bg="white"
              onChange={(date) => date && onChangeFiltro({ date })}
              value={filtro.date}
            />

            <SelectContaBancaria
              value={filtro.contasBancariasIds}
              mode="multiple"
              placeholder="Filtrar por conta bancária"
              onChange={(contasBancariasIds) => {
                onChangeFiltro({ contasBancariasIds });
              }}
              maxTagCount={1}
              allowClear
            />
          </Flex>
        }
        titleButton={hasPermissionImportar ? "Processar Arquivos" : undefined}
        onClick={() =>
          hasPermissionImportar ? setIsOpenModal(true) : undefined
        }
        // extraButtonTitle={"Filtrar"}
        // iconExtraButton={
        //   <>
        //     <FaFilter size={14} />
        //     <Flex right="10px" top="14px" position="absolute">
        //       <AiOutlinePlus size={9} />
        //     </Flex>
        //   </>
        // }
        // badge
        // badgeValueExtraButton={numeroFiltroSelecionados}
        // extraButtonOnClick={() => setModalFiltrosOpen(true)}
      />
      <Flex flexDir={"column"} justify={_items?.length ? "end" : "center"}>
        <Box mt={2}>
          <Row gutter={32} align="bottom">
            <Col sm={24}>
              <Flex
                h={10}
                bg={colors.white}
                justifyContent="center"
                align="center"
                mb={4}
                rounded="5px"
              >
                <Text fontSize="16px" fontWeight="bold" textAlign="center">
                  Lançamentos não Conciliados
                </Text>

                <Flex position="absolute" right={4}>
                  {data ? (
                    <ExportMenu
                      onExportarXlsx={() =>
                        exportExcelConciliacaoBancaria({
                          conciliacao: data,
                          mes: mesFiltro,
                        })
                      }
                    />
                  ) : null}
                </Flex>
              </Flex>
            </Col>
            <Col sm={24}>
              <DashboardConciliacao
                totais={dashboard}
                isLoading={isLoadingDashboard || isFetchingDashboard}
              />
            </Col>
          </Row>
          <Box as={Row} justifyContent="center" mb="10px">
            <Text fontSize="16px" fontWeight="bold">
              Dias do mês
            </Text>
          </Box>

          <ConciliacaoDias
            diasConciliacao={data?.dias || []}
            mes={mesFiltro}
            selectedDia={selectedDia}
            onClick={setSelectedDia}
          />
        </Box>

        {!isLoading && _items?.length ? (
          <Box>
            <Box as={Row} bg={colors.white} p="5px 20px" rounded="10px" mb={3}>
              <Col xs={12}>
                <Text fontSize="20px" fontWeight="500px">
                  Extrato Bancário
                </Text>
              </Col>
              <Col xs={12}>
                <Text fontSize="20px" fontWeight="500px" ml={4}>
                  No Sistema
                </Text>
              </Col>
            </Box>

            <Box rounded="16px">
              {_items.map((v) => (
                <Box mb="10px">
                  <TableConciliacao
                    value={v}
                    mes={mesFiltro}
                    diaTransacao={moment(v.data).format("DD")}
                    refetch={refetch}
                    totalContasSemExtrato={v.totalContasSemExtrato}
                    totalLiquidoNaoConciliadoDespesas={v.totalLiquidoDespesas}
                    totalLiquidoNaoConciliadoReceitas={v.totalLiquidoReceitas}
                    filtro={filtro}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        ) : !isLoading ? (
          <Box mt={8}>
            <Empty
              description={`Não há extrato bancário importado para esse ${
                selectedDia ? "dia" : "mês"
              }`}
            />
          </Box>
        ) : null}
      </Flex>

      <ModalProcessarArquivos
        visible={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        onSuccess={() => {
          refetch();
          setIsOpenModal(false);
        }}
      />

      {/* {modalFiltrosOpen ? (
        <ModalFiltroConciliacao
          visible={modalFiltrosOpen}
          onClose={() => setModalFiltrosOpen(false)}
          filtro={filtro}
          onChangeFiltro={onChangeFiltro}
          onReset={onResetFiltro}
        />
      ) : null} */}
    </>
  );
}

export default ListaConciliacaoBancaria;
